import React from "react";
import "./periodicMaintainanceService.css";
import { Link } from "react-router-dom";  
import { Helmet } from "react-helmet";
export default function PeriodicMaintenanceService() {
  return (
    <>
    <Helmet>
      <title>Periodic Maintenance Service for Your Car | AutoCare</title>
      <meta
        name="description"
        content="Keep your vehicle running smoothly with professional periodic maintenance service at AutoCare in Palwal. Our expert car servicing includes oil changes, brake checks, fluid top-ups, and more."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/periodic-maintenance"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">
        {/* Left side text */}
        <div className="textContent">
          <h1>Periodic Maintenance Service for Your Car</h1>

          <p>
            Regular <strong>Periodic Maintenance Service (PMS)</strong> is essential
            to keep your vehicle running smoothly, safely, and efficiently. At
            <strong> AutoCare</strong>, we offer professional and affordable
            <span className="highlight"> periodic car maintenance services</span>
            designed to extend your car’s life and improve overall performance.
          </p>

          <h2>What Is Periodic Maintenance Service?</h2>
          <p>
            Periodic Maintenance Service is a routine <span className="highlight">
            car servicing</span> process carried out at regular intervals based on
            your car’s mileage or time period. It helps identify potential issues
            early and prevents costly repairs in the future.
          </p>

          <h2>What’s Included in Our Periodic Car Service?</h2>
          <ul>
            <li>Engine oil change and oil filter replacement</li>
            <li>Air filter and cabin filter inspection or replacement</li>
            <li>Brake inspection and fluid check</li>
            <li>Coolant, washer fluid, and power steering fluid top-up</li>
            <li>Battery health check</li>
            <li>Tyre pressure check and rotation</li>
            <li>Complete vehicle inspection report</li>
          </ul>

          <h2>Why Choose AutoCare for Periodic Maintenance?</h2>
          <p>
            When you choose <strong>AutoCare</strong> for your
            <span className="highlight"> periodic maintenance service</span>,
            you get expert technicians, genuine spare parts, and transparent pricing.
            Our goal is to deliver reliable <span className="highlight">
            car maintenance services</span> that keep your vehicle in top condition.
          </p>

          <h2>Benefits of Regular Periodic Car Service</h2>
          <ul>
            <li>Improves engine performance and fuel efficiency</li>
            <li>Reduces unexpected breakdowns</li>
            <li>Enhances safety and driving comfort</li>
            <li>Increases vehicle resale value</li>
            <li>Ensures long-term reliability of your car</li>
          </ul>

          <h2>Book Periodic Maintenance Service with AutoCare</h2>
          <p>
            Looking for a trusted <span className="highlight">
            car service near me</span>? With <strong>AutoCare</strong>, you can easily
            book <span className="highlight">periodic maintenance service</span>
            online or contact our team directly. We also provide
            <span className="highlight"> car service at home</span> for maximum
            convenience.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Periodic Maintenance Service
            </Link>
          </button>
        </div>

        {/* Right side image */}
        <div className="imageContent">
          <img src='/carServiceImages/periodicServiceMaintainance.webp' alt="Periodic Car Maintenance" />
        </div>
      </div>
    </section>
    </>
  );
}
